// extracted by mini-css-extract-plugin
module.exports = {"imgStyle":"style_imgStyle__3Begt","imageWrapper":"style_imageWrapper__1o0T9","image":"style_image__1FyLu"};